export const FILTER_POST = 'FILTER_POST';
export const CLEAR_POSTS = 'CLEAR_POSTS';
export const STORE_POST = 'STORE_POST';
